<template>
  <div>
    <n-table-view
        ref="table"
        name="Список"
        class="table3"
        :genRequestBuilder="requestBuilder"
        :height="height"
        :headers="[
        { text: 'ID', value: 'id', class:'text-no-wrap'},
        { text: 'Название', value: 'name', class:'text-no-wrap'},
        { text: 'Текст', value: 'text', class:'text-no-wrap'},
        { text: 'Дата отправки / Задержка (сек.) / Отправить через', value: 'sendDate', sortable:false,  class:'text-no-wrap'},
        { text: 'Создал', value: 'userAuthor.id',  class:'text-no-wrap'},
        { text: 'Статус / Всего / Успешно', value: 'status', sortable:false, class:'text-no-wrap'},
        { text: 'Создано', value: 'created',  class:'text-no-wrap'},
      ]"
      autoUpdate
    >
      <template v-slot:item="{ item }">
        <tr @click="loadDetail(item)">
          <td class="text-no-wrap">{{ item.id }}</td>
          <td class="text-no-wrap">{{ item.name }}</td>
          <td class="text-wrap">{{ item.text }}</td>
          <td class="text-wrap">
            {{ $tools.dateTimeFormat(item.sendDate, 'DD.MM.YYYY HH:mm') }}<br/>
            {{ item.delay }} сек.<br/>
            <div>
              <span class="text-no-wrap">{{ item.comContact.name }}</span>
              <dot/>
              <v-icon :color="item.comContactInfo.messengerTypeIconBgColor" small>
                {{ item.comContactInfo.messengerTypeIcon }}
              </v-icon>
              <span class="text-no-wrap ml-1">{{ item.comContactInfo.messengerTypeStr }}</span>
              <dot/>
              <span class="text-no-wrap">{{ $tools.phoneFormat(item.comContact.phone) }}</span>
            </div>
          </td>
          <td class="text-wrap">
            <user-full-name :user="item.userAuthor"/>
          </td>
          <td class="text-no-wrap">
            <chip>
              <span v-if="item.status==='queue'">В очереди</span>
              <span v-if="item.status==='progress'">В процессе</span>
              <span v-if="item.status==='success'">Успешно</span>
              <v-progress-circular
                  v-if="item.status==='progress' && item.progress>0"
                  :value="item.progress" color="primary" class="ml-1" size="18" rotate="-90"
              />
            </chip>
            <div>{{item.messagesTotal.count}}</div>
            <div>{{item.messagesTotal.success}}</div>
          </td>
          <td class="text-no-wrap">{{ $tools.dateTime(item.created) }}</td>
        </tr>
      </template>
    </n-table-view>
    <dialog-view
        :open="detailState.modal"
        :title="'Просмотр рассылки '+detailState.data1"
        :loading="detailState.loading"
        @cancel="detailState.modalClose()"
        content-full-size big
    >
      <template v-slot:content>
        <v-simple-table v-if="detailState.success" class="pa-0" dense fixed-header :height="height*0.8">
          <thead>
          <tr>
            <th class="text-no-wrap">ID</th>
            <th class="text-no-wrap">Ф.И.О</th>
            <th class="text-no-wrap">Текст</th>
            <th class="text-no-wrap">Статус</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(v, k) in detailState.data?.items[0].messages" :key="k">
            <td class="text-no-wrap">{{ v.id }}</td>
            <td class="text-no-wrap">
              <user-full-name :user="v"/>
            </td>
            <td class="text-wrap">{{ v.text }}</td>
            <td class="text-no-wrap">
              <chip v-if="v.status==='queue'">В очереди</chip>
              <chip v-if="v.status==='success'" color="green" dark>Успешно</chip>
              <chip v-if="v.status==='error'" color="red" dark>Ошибка</chip>
              <chip v-if="v.status==='cancel'" color="orange" dark>Отменено</chip>
              <tooltip v-if="!$tools.isEmpty(v.statusMessage)" bottom>
                <template v-slot:default>
                  <v-icon small class="ml-2">mdi-comment-text-outline</v-icon>
                </template>
                <template v-slot:content>
                  {{ v.statusMessage }}
                </template>
              </tooltip>
            </td>
          </tr>
          </tbody>
        </v-simple-table>
      </template>
    </dialog-view>
  </div>
</template>

<script>

import {
  Entity_ComContact,
  Entity_Distribute,
  Entity_User,
  Entity_UserProfile
} from "../../../../../EntityStoreCacheService";
import Dot from "@/componentsV2/base/Dot.vue";
import NTableView from "@/componentsV2/base/NTableView.vue";
import Chip from "@/componentsV2/base/Chip.vue";
import DialogView from "@/components/DialogView.vue";
import Stater from "@/plugins/stater";
import UserFullName from "@/componentsV2/custom/UserFullName.vue";
import Tooltip from "@/componentsV2/base/Tooltip.vue";

export default {
  components: {Tooltip, UserFullName, DialogView, Chip, NTableView, Dot},
  props: ['height'],
  data: () => ({
    loadState: new Stater(),
    detailState: new Stater(),
  }),
  mounted() {
  },
  methods: {
    requestBuilder(page, onPage, sortFields) {
      return new Entity_Distribute()
          .selects(Entity_Distribute.id)
          .selects(Entity_Distribute.name)
          .selects(Entity_Distribute.text)
          .selects(Entity_Distribute.status)
          .selects(Entity_Distribute.created)
          .selects(Entity_Distribute.sendDate)
          .selects(Entity_Distribute.delay)
          .selects(Entity_Distribute.progress)
          .selects([Entity_Distribute.userAuthor, Entity_User.id].join('.'))
          .selects([Entity_Distribute.userAuthor, Entity_User.type].join('.'))
          .selects([Entity_Distribute.userAuthor, Entity_User.firstName].join('.'))
          .selects([Entity_Distribute.userAuthor, Entity_User.lastName].join('.'))
          .selects([Entity_Distribute.userAuthor, Entity_User.secondName].join('.'))
          .selects([Entity_Distribute.userAuthor, Entity_User.userProfile, Entity_UserProfile.id].join('.'))
          .selects([Entity_Distribute.comContact, Entity_ComContact.name].join('.'))
          .selects([Entity_Distribute.comContact, Entity_ComContact.phone].join('.'))
          .virtual(Entity_Distribute.virtual_comContactInfo)
          .virtual(Entity_Distribute.virtual_messagesTotal)
          //.virtual(Entity_Distribute.virtual_messages)
          .page(page)
          .onPage(onPage)
          .orderFromTable(sortFields)
          .addStateCallback(v => this.loadState.setRequestBuilderState(v))
          .addStateCallback((v) => {
            if (v.error)
              this.$store.commit('alertError', 'Ошибка загрузки данных.Если ошибка повторяется, обратитесь в тех. поддержку');
          })
    },
    loadDetail(item) {
      this.detailState.modalOpen(null, item.name);
      new Entity_Distribute()
          .selects(Entity_Distribute.id)
          .selects(Entity_Distribute.name)
          .virtual(Entity_Distribute.virtual_messages)
          .filterAnd([Entity_Distribute.entity, Entity_Distribute.id].join('.')+'=?', item.id)
          .addStateCallback(v => this.detailState.setRequestBuilderState(v))
          .request();
    }
  }
}
</script>